export enum Opacity {
  ForSmall = 0.24,
  ForLarge = 0.72,
}
